import { useState } from 'react';
import { useAuthenticatedFetchWithWorkspace } from '../Keycloak/useAuthenticatedFetchWithWorkspace';

const useDeleteContact = () => {
    const { authFetch, isReady, workspaceId } = useAuthenticatedFetchWithWorkspace();
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string>('');

    const deleteContact = async (contactId: string | number): Promise<boolean> => {
        if (!isReady || !workspaceId) {
            setError('Workspace not ready');
            return false;
        }

        setIsLoading(true);
        setError('');
        try {
            await authFetch('/deleteEntContact', {
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ contact_id: contactId }),
            });
            return true;
        } catch (err: unknown) {
            const message = err instanceof Error ? err.message : 'Unknown error while deleting the contact.';
            console.error('[useDeleteContact] failed:', { workspaceId, contactId, message });
            setError(message);
            return false;
        } finally {
            setIsLoading(false);
        }
    };

    return { deleteContact, isLoading, error };
};

export default useDeleteContact;
